import React, { FC } from 'react';
import { useTheme } from 'styled-components';

interface IKPIIndicator {
  indicator: number;
  value: number;
}

const KPIIndicator: FC<IKPIIndicator> = ({ indicator, value }) => {
  const theme = useTheme();

  const COLOR =
    value <= 30
      ? theme.colors.accent.red[100]
      : value > 30 && value <= 70
        ? theme.colors.accent.blue[100]
        : theme.colors.accent.green[100];

  return (
    <g style={{ transform: 'translate(50%, 148px)' }}>
      <path
        d="M87.4903 0C89.9063 0 91.8648 1.79086 91.8648 4C91.8648 6.20914 89.9063 8 87.4903 8C85.0743 8 0 6.20914 0 4C0 1.79086 85.0743 0 87.4903 0Z" // eslint-disable-line
        fill={theme.colors.neutral.primary[70]}
        pathLength={100}
        strokeWidth={1}
        stroke={theme.colors.neutral.primary[0]}
        style={{
          transform: `translate(-84px, -4px) rotateZ(${(indicator / 100) * 180}deg)`,
          transformOrigin: 'calc(100% - 8px) center',
          transformBox: 'fill-box',
          transitionTimingFunction: 'cubic-bezier(0.17, 0.67, 0.83, 0.67)',
          transition: 'all 0.5s',
        }}
      />
      <g>
        <circle cx={0} cy={0} r={24} fill={COLOR} />
        <text
          x={0}
          y={0}
          dx={0}
          dy={8}
          fill={theme.colors.neutral.primary[0]}
          fontSize={24}
          fontWeight={700}
          textAnchor="middle"
        >
          {value}
        </text>
      </g>
    </g>
  );
};

export default KPIIndicator;
